export default "__VITE_PUBLIC_ASSET__9ed54282__"